import { render, staticRenderFns } from "./orderListRow.vue?vue&type=template&id=4e10ff3f&scoped=true&"
import script from "./orderListRow.vue?vue&type=script&lang=js&"
export * from "./orderListRow.vue?vue&type=script&lang=js&"
import style0 from "./orderListRow.vue?vue&type=style&index=0&id=4e10ff3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10ff3f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
